import React, { useState } from "react";
import Navigate from "../../components/Navigate/index";
import Modes from "../../components/Cards/Mode/index";
import Button from "../../components/ui/Buttons";
import BreadCrumb from "../../components/Breadcrumbs/Breadcrumb";
import Alert from "../../components/ui/Alerts/index";
const Mode = () => {
  const [selectedMode, setSelectedMode] = useState(null);
  const handleModeSelect = (mode) => {
    setSelectedMode(mode);
  };
  return (
    <>
      <BreadCrumb />
      <div className="px-[4px] lg:px-[16px]">
        <Alert value="Sorularınız sadece bir ders ve konudan oluşacaktır." />
      </div>
      <div className="w-100 bg-white rounded-[12px] mx-[4px] lg:mx-[16px] my-[24px] p-[16px]">
        <Navigate title="Test Modu Seçin" />
        <div>
          <form>
            <Modes
              onSelectMode={handleModeSelect}
              selectedMode={selectedMode}
            />
            <Button
              value="Onayla"
              disabled={!selectedMode}
              path="/smarttest/subject/mode/start"
            />
          </form>
        </div>
      </div>
    </>
  );
};

export default Mode;
